module.exports = "/_next/static/images/become-a-mythical-beast-17b29594980e9346ed6dc2efbfc0b111.svg";